const STORAGE_KEY = 'clc_cookie_consent';

export const CONSENT_VERSION = 1;

export const defaultConsent = () => ({
  version: CONSENT_VERSION,
  necessary: true,
  analytics: false,
  advertising: false,
  decided: false,
});

export const readConsent = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultConsent();
    const parsed = JSON.parse(raw);
    if (parsed?.version !== CONSENT_VERSION) return defaultConsent();
    return { ...defaultConsent(), ...parsed, necessary: true };
  } catch {
    return defaultConsent();
  }
};

export const saveConsent = (consent) => {
  const payload = {
    ...defaultConsent(),
    ...consent,
    necessary: true,
    decided: true,
    version: CONSENT_VERSION,
    updatedAt: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  return payload;
};

export const hasAnalyticsConsent = (consent) => Boolean(consent?.analytics);
export const hasAdvertisingConsent = (consent) => Boolean(consent?.advertising);
